import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import Constants from '../../../definitions/constants';
import EngineFunctionsDefinition from '../../../definitions/engineFunctionsDefinition';
import TableDescriptors from '../../../definitions/tableDescriptors';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import FormatTooling from '../../../tooling/formatTooling';
import FormulaUtilsTooling from '../../../tooling/formulaUtilsTooling';
import EntityTableTooling from '../../../tooling/entityTableTooling';
import { intl } from '../../../locales/localesConfig';
import toastr from 'toastr';
import $ from 'jquery';

/* Actions */
import * as formulaEditorActions from '../../actions/formulaEditor/index';

/*Components*/
import FormulaEditorPopup from '../../components/formulaEditor/formulaEditorPopup';
import ImportFormulaGrammarPopup from '../../components/formulaEditor/importFormulaGrammarPopup';
import GlassConfirmPopup from '../../components/common/interface/glassConfirmPopup';

const popupIds = {
  importFormulaGrammarPopup: "importFormulaGrammarPopup",
  closeFormulaConfirmPopup: "closeFormulaConfirmPopup",
}

class FormulaEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formulaEditorDragingEntity: null,
      formulaEditorEditingEntityId: null,
      formulaEditorMarkModeData: null,
      formulaEditorCopyData: null,
      formulaEditorCutData: null,
      formulaEditorIsPasting: null,
      formulaEditorCopiedFormula: null,   
      formulaEditorOptions: {
        disableMarkMode: false,
        finalPath: "",
        disableFunctions: []
      },
      formulaImportText: "",
      blockEscBehaviour: false,
      formulaEditorHideDraggables: false,
      formulaHasChanges: false,
    };
  }

  async componentDidMount() {
    await this.props.actions.getDimensionsList();
    await this.props.actions.getMetricsList();
    await this.props.actions.getPolynomialsList();
    this.addEscEventListener()    
  }

  componentWillUnmount() {
    this.removeEscEventListener();
  }
 
  shouldComponentUpdate(nextProps, nextState) {
    if(!InterfaceTooling.popupHasToRender(this.props.popupState) && 
      InterfaceTooling.popupHasToRender(nextProps.popupState)) {
        this.setState({
          formulaEditorDragingEntity: null,
          formulaEditorEditingEntityId: null,
          formulaEditorMarkModeData: null,
          formulaEditorCopyData: null,
          formulaEditorCutData: null,
          formulaEditorIsPasting: null, 
          formulaEditorOptions: nextProps.formulaEditorOptions,
          formulaHasChanges: false,
        });
        // so the setState in didUpdate had time to take effect
        return false;
      }
      return true;
  }
  
  componentDidUpdate(prevProps, prevState) {
    if(this.props.formulaGrammarValidation.status == 200 && prevProps.formulaGrammarValidation.status != 200) {
      if(InterfaceTooling.popupHasToRender(this.state[popupIds.importFormulaGrammarPopup])) {
        InterfaceTooling.popupHide(popupIds.importFormulaGrammarPopup, this.setState.bind(this));
      }
    }
  }

  componentWillUnmount() {
    this.props.actions.reset();
  }

  handleValidateAndSet = (event) => {
    this.setState({
      formulaEditorEditingEntityId: null,
      formulaEditorMarkModeData: null,
      formulaEditorCopyData: null,
      formulaEditorCutData: null,
      formulaEditorIsPasting: null
    });
    $(".formula_editor_highlight_mark_left").removeClass("formula_editor_highlight_mark_left");
    $(".formula_editor_highlight_mark_right").removeClass("formula_editor_highlight_mark_right");
    $(".formula_editor_highlight_left").removeClass("formula_editor_highlight_left");
    $(".formula_editor_highlight_right").removeClass("formula_editor_highlight_right");
    this.props.actions.formulaValidation(this.props.formulaToEditObject);
  };

  onDragStart = (result) => {
    let dragItem = null;
    let idItem = result.draggableId.replace(result.type + "_", "");
    switch (result.type) {
      case Constants.formulaEditor.objectTypes.polynomial:
        dragItem = this.props.polynomialsList.data.find(item => item.id==idItem);
        break;
      case Constants.formulaEditor.objectTypes.metric:
        dragItem = this.props.metricsList.data.find(item => item.id==idItem);
        if(!dragItem && this.props.metricsList.additionalData && this.props.metricsList.additionalData.virtual_calculation_metric && idItem == -1) {
          dragItem = this.props.metricsList.additionalData.virtual_calculation_metric;
        }
        break;
      case Constants.formulaEditor.objectTypes.dimension: 
        dragItem = this.props.dimensionsList.data.find(item => item.id==idItem);
        break;
      case Constants.formulaEditor.objectTypes.function:
        dragItem = this.props.functionsList.find(item => item.id==idItem);
        break;
      default:
    }
    if(dragItem) {
      dragItem = JavascriptUtilsTooling.deepCopy(dragItem);
      dragItem.entityType = result.type;
    } else {
      dragItem = null;
    }
    this.setState({
      formulaEditorDragingEntity: dragItem
    });
  };

  onDragEnd = (result) => {
    this.setState({
      formulaEditorDragingEntity: null
    });
  };

  onDragEndOnTarget = (event) => {
    if(this.state.formulaEditorDragingEntity) {
      toastr.options = Constants.interface.tostrOptions;
      let parentId = event.currentTarget.dataset.parentid;
      let formulaAdditionalData = FormulaUtilsTooling.getFormulaAdditionalDataFromParentId(this.props.formulaToEditObject, parentId);
      let index = event.currentTarget.dataset.index;
      let onlyAcceptOneObject = event.currentTarget.dataset.onlyacceptoneobject;
      if(onlyAcceptOneObject) {
        onlyAcceptOneObject = JSON.parse(onlyAcceptOneObject);
      }
      let target = event.currentTarget;
      let cursorSide = JavascriptUtilsTooling.getMouseCursorSideOnElement(event);
      target.classList.remove("formula_editor_highlight_left");
      target.classList.remove("formula_editor_highlight_right");
      let validObject = true;
      if(onlyAcceptOneObject) {
        if(onlyAcceptOneObject.entityTypes && !onlyAcceptOneObject.entityTypes.includes(this.state.formulaEditorDragingEntity.entityType)) {
          toastr.error(intl.formatMessage({ id: "polynomialAdmin.formulaEditor.invalidObject"}),"");
          validObject = false;
        }
        else if(this.state.formulaEditorDragingEntity.entityType != "Metric" &&
            onlyAcceptOneObject.ids && !onlyAcceptOneObject.ids.includes(this.state.formulaEditorDragingEntity.id)) {
          toastr.error(intl.formatMessage({ id: "polynomialAdmin.formulaEditor.invalidObject"}),"");
          validObject = false;
        }
        else if(this.state.formulaEditorDragingEntity.entityType == "Metric" &&
            onlyAcceptOneObject.metricBehaviour == Constants.formulaEditor.metricBehaviour.LOADABLE_METRIC &&
            this.state.formulaEditorDragingEntity.metric_type != Constants.metricAdmin.metricType.DYNAMIC) {
          toastr.error(intl.formatMessage({ id: "polynomialAdmin.formulaEditor.invalidObjectLoadMetric"}),"");
          validObject = false;
        }
      }
      if(formulaAdditionalData.inSumX && this.state.formulaEditorDragingEntity.entityType == "Function" && 
         (this.state.formulaEditorDragingEntity.id == EngineFunctionsDefinition.functionsList.SUMX.code || 
          this.state.formulaEditorDragingEntity.id == EngineFunctionsDefinition.functionsList.REDUCEX.code)) {
        toastr.error(intl.formatMessage({ id: "polynomialAdmin.formulaEditor.invalidObjectSumx"}),"");
        validObject = false;
      }
      if(validObject) {
        let contextInfo = {};
        if(onlyAcceptOneObject && this.state.formulaEditorDragingEntity.entityType == "Metric" &&
            onlyAcceptOneObject.metricBehaviour == Constants.formulaEditor.metricBehaviour.LOADABLE_METRIC &&
            this.state.formulaEditorDragingEntity.metric_type == Constants.metricAdmin.metricType.DYNAMIC) {
          contextInfo.loadMetricModeActive = true;
        }
        this.props.actions.editFormulaToEditObject(parentId, index, cursorSide, this.state.formulaEditorDragingEntity, contextInfo);
        this.setState({ formulaHasChanges: true })
      }
      this.setState({
        formulaEditorDragingEntity: null
      });
    }
  };

  onDragOver = (event) => {
    if(this.state.formulaEditorDragingEntity || 
        this.state.formulaEditorMarkModeData!=null ||
        this.state.formulaEditorCopyData!=null ||
        this.state.formulaEditorCutData!=null ||
        this.state.formulaEditorIsPasting!=null) {
      let target = event.currentTarget;
      let cursorSide = JavascriptUtilsTooling.getMouseCursorSideOnElement(event);
      if(cursorSide==1) {
        target.classList.remove("formula_editor_highlight_left");
        target.classList.add("formula_editor_highlight_right");
      }
      else {
        target.classList.add("formula_editor_highlight_left");
        target.classList.remove("formula_editor_highlight_right"); 
      }
    }
  };

  checkFormulaEditorSegment = (segmentArray) => {
    toastr.options = Constants.interface.tostrOptions;
    if(!segmentArray || segmentArray.length<2) {
      return false;
    }
    else if(segmentArray[0].parentId!=segmentArray[1].parentId) {
      toastr.error(intl.formatMessage({ id: "polynomialAdmin.formulaEditor.topControlsButtons.invalidSegmentDifferentParent"}),"");
      return false;
    }
    else if(segmentArray[1].index<segmentArray[0].index || (segmentArray[1].index==segmentArray[0].index && segmentArray[1].cursorSide<=segmentArray[0].cursorSide)) {
      toastr.error(intl.formatMessage({ id: "polynomialAdmin.formulaEditor.topControlsButtons.invalidSegmentInvalidLength"}),"");
      return false;
    }
    else if(false) {
      toastr.error(intl.formatMessage({ id: "polynomialAdmin.formulaEditor.topControlsButtons.invalidSegmentParenthesis"}),"");
      return false;
    }
    return true;
  }

  onClickFormulaEditorAction = (event) => {
    if(this.state.formulaEditorMarkModeData!=null ||
        this.state.formulaEditorCopyData!=null ||
        this.state.formulaEditorCutData!=null ||
        this.state.formulaEditorIsPasting!=null) {
      let functionEnded = false;
      let positionObject = {
        parentId: event.currentTarget.dataset.parentid,
        index: +event.currentTarget.dataset.index,
        cursorSide: JavascriptUtilsTooling.getMouseCursorSideOnElement(event)
      };      
      toastr.options = Constants.interface.tostrOptions;
      if(this.state.formulaEditorMarkModeData!=null) {
        this.state.formulaEditorMarkModeData.push(positionObject)
        if(this.state.formulaEditorMarkModeData.length==2) {
          functionEnded = true;
          if(this.checkFormulaEditorSegment(this.state.formulaEditorMarkModeData)) {
            let positionObjectStart = this.state.formulaEditorMarkModeData[0];
            let indexStart = positionObjectStart.cursorSide==-1 ? positionObjectStart.index : positionObjectStart.index+1;
            let entityId = positionObjectStart.parentId + indexStart;
            this.props.actions.editFormulaAddMark(this.state.formulaEditorMarkModeData);
            this.setState({
              formulaEditorEditingEntityId: entityId
            });
            toastr.success(intl.formatMessage({ id: "polynomialAdmin.formulaEditor.topControlsButtons.markModeSuccess"}),"");
          }
        }
      }
      else if(this.state.formulaEditorCopyData!=null) {
        this.state.formulaEditorCopyData.push(positionObject)
        if(this.state.formulaEditorCopyData.length==2) {
          functionEnded = true;
          if(this.checkFormulaEditorSegment(this.state.formulaEditorCopyData)) {
            this.setState({
              formulaEditorCopiedFormula: FormulaUtilsTooling.copyFormula(this.props.formulaToEditObject, this.state.formulaEditorCopyData)
            });
            toastr.success(intl.formatMessage({ id: "polynomialAdmin.formulaEditor.topControlsButtons.copySuccess"}),"");
          }
        }
      }
      else if(this.state.formulaEditorCutData!=null) {
        this.state.formulaEditorCutData.push(positionObject)
        if(this.state.formulaEditorCutData.length==2) {
          functionEnded = true;
          if(this.checkFormulaEditorSegment(this.state.formulaEditorCutData)) {
            this.setState({
              formulaEditorCopiedFormula: FormulaUtilsTooling.copyFormula(this.props.formulaToEditObject, this.state.formulaEditorCutData)
            });
            this.props.actions.editFormulaCut(this.state.formulaEditorCutData);
            toastr.success(intl.formatMessage({ id: "polynomialAdmin.formulaEditor.topControlsButtons.cutSuccess"}),"");
          }
        }
      }
      else if(this.state.formulaEditorIsPasting!=null) {
        functionEnded = true;
        if(this.state.formulaEditorCopiedFormula!=null) {
          this.props.actions.editFormulaPaste(positionObject, this.state.formulaEditorCopiedFormula);
          toastr.success(intl.formatMessage({ id: "polynomialAdmin.formulaEditor.topControlsButtons.pasteSuccess"}),"");
        }
        else {
          toastr.options = Constants.interface.tostrOptions;
          toastr.error(intl.formatMessage({ id: "polynomialAdmin.formulaEditor.topControlsButtons.noFormulaToCopy"}),"");
        }
      }
      if(!functionEnded) {
        let target = event.currentTarget;
        let cursorSide = JavascriptUtilsTooling.getMouseCursorSideOnElement(event);
        if(cursorSide==1) {
          target.classList.add("formula_editor_highlight_mark_right");
        }
        else {
          target.classList.add("formula_editor_highlight_mark_left");
        }
      }
      else {
        $(".formula_editor_highlight_mark_left").removeClass("formula_editor_highlight_mark_left");
        $(".formula_editor_highlight_mark_right").removeClass("formula_editor_highlight_mark_right");
        $(".formula_editor_highlight_left").removeClass("formula_editor_highlight_left");
        $(".formula_editor_highlight_right").removeClass("formula_editor_highlight_right");
        this.setState({
          formulaEditorMarkModeData: null,
          formulaEditorCopyData: null,
          formulaEditorCutData: null,
          formulaEditorIsPasting: null,        
        });
      }
    }
  };

  onChangeFormulaText = (event) => {
    let parentId = event.currentTarget.dataset.parentid;
    let index = event.currentTarget.dataset.index;
    let value = event.currentTarget.value;
    this.props.actions.editFormulaToEditObject(parentId, index, 0, value);
    this.setState({ formulaHasChanges: true })
  };

  onClickFormulaEntity = (event) => {
    if(this.state.formulaEditorMarkModeData==null &&
        this.state.formulaEditorCopyData==null &&
        this.state.formulaEditorCutData==null &&
        this.state.formulaEditorIsPasting==null) {
      let entityId = event.currentTarget.dataset.entityid;
      let id = "#" + event.currentTarget.id;
      if(entityId==this.state.formulaEditorEditingEntityId) {
        this.setState({
          formulaEditorEditingEntityId: null
        });   
      }
      else {
        this.props.actions.changeCollapseFormulaEntity(entityId, true);
        this.setState({
          formulaEditorEditingEntityId: entityId
        });
        InterfaceTooling.delayCallAction(
          ()=>{
            let dom_search = $(id);
            if(dom_search.length>0) {
              dom_search[0].scrollIntoView({block: "center", behavior: "smooth"});
            }
          },null);
      }
    }
  };

  onEditEntityEditor = (event) => {
    let polynomialDimensionEditor = event.currentTarget.dataset.polynomialdimensioneditor;
    let paramTableEditor = event.currentTarget.dataset.paramtableeditor;
    let metricDimensionEditor = event.currentTarget.dataset.metricdimensioneditor;
    let functionParamEditor = event.currentTarget.dataset.functionparameditor;
    let isOption = event.currentTarget.dataset.isoption;
    if(polynomialDimensionEditor || metricDimensionEditor || paramTableEditor || functionParamEditor) {
      let value = JSON.parse(event.currentTarget.dataset.value);
      let isDelete = event.currentTarget.dataset.delete;
      let index = event.currentTarget.dataset.index;
      let isEdit = event.currentTarget.dataset.edit;
      if(!paramTableEditor) {
        value.dimension_name = this.props.dimensionsList.data.find(item => item.id==value.dimension_id);
        value.dimension_name = value.dimension_name ? value.dimension_name.name : "";
      }
      this.props.actions.editFormulaToEditObjectEntityData(this.state.formulaEditorEditingEntityId, "childs", {
        isEdit: isEdit,
        isDelete: isDelete,
        index: index,
        value: value,
      });
    }
    else if(isOption) {
      let path = event.currentTarget.dataset.path;
      let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
      this.props.actions.editFormulaToEditObjectEntityData(this.state.formulaEditorEditingEntityId, "options", {
        name: path,
        value: value
      });
    }
    else {
      let path = event.currentTarget.dataset.path;
      let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
      let objectData = {
        value: value
      };
      if(path == "calculation_metric_polynomial_name" && value) {
        objectData.pivotDimension = null;
        let polynomialFounded = this.props.polynomialsList.data.find(item => item.name.toUpperCase() == value.toUpperCase());
        if(polynomialFounded) {
          objectData.pivotDimension = this.props.dimensionsList.data.find(item => item.id==polynomialFounded.sub_model_dimension_id);
        }
      }
      else if(path=="order_by_descriptor") {
        objectData.value = JSON.parse(event.currentTarget.dataset.value);
        objectData.index = event.currentTarget.dataset.index;
        objectData.isDelete = event.currentTarget.dataset.delete;
        objectData.isEdit = event.currentTarget.dataset.edit;
      }
      this.props.actions.editFormulaToEditObjectEntityData(this.state.formulaEditorEditingEntityId, path, objectData);
    }
    this.setState({ formulaHasChanges: true })
  };

  handleChangeCollapseFormulaEntity = (event) => {
    let entityId = event.currentTarget.dataset.entityid;
    this.props.actions.changeCollapseFormulaEntity(entityId);
    event.stopPropagation();
  };

  handleChangeCollapseAllFormulaEntity = (event) => {
    let collapse = event.currentTarget.dataset.collapse;
    this.props.actions.changeCollapseAllFormulaEntity(collapse);
  };
  
  handleDeleteFormulaEntity = (event) => {
    this.props.actions.deleteFormulaEntity(this.state.formulaEditorEditingEntityId);
    this.setState({
      formulaEditorEditingEntityId: null
    });
  };

  onCloseEntityEditor = (event) => {
    this.setState({
      formulaEditorEditingEntityId: null
    });
  };

  setEscBehaviour = (overlay) => {
    this.setState({
      blockEscBehaviour: overlay,
    });
  }

  // Function that handles the "ESC" key behaviour when editing a formula's entity's parameters
  escEventListener = (event) => {
    if(event.key == "Escape" && !this.state.blockEscBehaviour && this.state.formulaEditorEditingEntityId){
      this.onCloseEntityEditor();
    }
  }

  addEscEventListener = () => {
    return document.addEventListener('keydown', this.escEventListener);
  }

  removeEscEventListener = () => {
    return document.removeEventListener('keydown', this.escEventListener);
  }

  handleFormulaEditorControlButtons = (event) => {
    let action = event.currentTarget.dataset.action;
    if(this.state.formulaEditorMarkModeData!=null ||
        this.state.formulaEditorCopyData!=null ||
        this.state.formulaEditorCutData!=null ||
        this.state.formulaEditorIsPasting!=null) {
      $(".formula_editor_highlight_mark_left").removeClass("formula_editor_highlight_mark_left");
      $(".formula_editor_highlight_mark_right").removeClass("formula_editor_highlight_mark_right");
      this.setState({
        formulaEditorMarkModeData: null,
        formulaEditorCopyData: null,
        formulaEditorCutData: null,
        formulaEditorIsPasting: null,        
      });
    }
    else if(action=="mark_mode") {
      this.setState({
        formulaEditorMarkModeData: []
      });
    }
    else if(action=="copy") {
      this.setState({
        formulaEditorCopyData: []
      });
    }
    else if(action=="cut") {
      this.setState({
        formulaEditorCutData: []
      });
    }
    else if(action=="paste") {
      this.setState({
        formulaEditorIsPasting: true
      });
    }
  };

  handleDimensionInstancesSelectControl = (keyword, additinalData) => {
    this.props.actions.getDimenesionInstancesSelect({
      dimension_id: additinalData,
      filter: keyword
    });
  };

  handleImportFormulaGrammarPopup = event => { 
    InterfaceTooling.handleShowPopup(
      event, popupIds.importFormulaGrammarPopup, this.state, 
      this.setState.bind(this), false
    );
  };

  handleOnChangeImportFormulaFromGrammarForm = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    this.setState({
      formulaImportText: value,
    });
  }

  handleImportFormulaFromGrammar = (event) => {
    this.props.actions.formulaGrammarValidation({formula_grammar: this.state.formulaImportText});
  }

  handleHideEditorDraggables = (event) => {
    this.setState({
      formulaEditorHideDraggables: !this.state.formulaEditorHideDraggables
    });
  }

  handleCloseFormula = async(event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.closeFormulaConfirmPopup, this.state, 
      this.setState.bind(this)
    );    
    this.props.handleShowFormulaEditorPopup(event);
    this.setState({ formulaHasChanges: false })
  }

  handleShowFormulaEditorPopupWithConfirmation = (event) => {
    if(this.state.formulaHasChanges) {
      InterfaceTooling.handleShowPopup(
        event, popupIds.closeFormulaConfirmPopup, this.state, 
        this.setState.bind(this), false
      );
    } else {
      this.props.handleShowFormulaEditorPopup(event);
      this.setState({ formulaHasChanges: false })
    }
  }    

  render() {
    const {
      handleShowFormulaEditorPopup,
      formulaEditorOptions,
      popupState
    } = this.props;

    let metricsList = this.props.metricsList.data
    if(this.props.metricsList.data && this.props.metricsList.additionalData){
      metricsList = [this.props.metricsList.additionalData.virtual_calculation_metric].concat(this.props.metricsList.data);
    }
    return (
      <React.Fragment>
        <FormulaEditorPopup
          handleShowPopup={this.handleShowFormulaEditorPopupWithConfirmation}
          fullLoading={this.props.formulaValidation.loading || this.props.dimensionsList.loading ||
            this.props.metricsList.loading || this.props.polynomialsList.loading || this.props.calendarsList.loading}
          notRender={this.props.dimensionsList.loading ||
            this.props.metricsList.loading || this.props.polynomialsList.loading || this.props.calendarsList.loading}
          formulaToEditObject={this.props.formulaToEditObject}
          formulaEditorOptions={this.state.formulaEditorOptions}
          handleValidateAndSet={this.handleValidateAndSet}
          validationStatus={this.props.formulaValidation.status}
          markModeData={this.state.formulaEditorMarkModeData}
          copyData={this.state.formulaEditorCopyData}
          cutData={this.state.formulaEditorCutData}
          isPasting={this.state.formulaEditorIsPasting}
          copiedFormula={this.state.formulaEditorCopiedFormula}
          handleControlButtons={this.handleFormulaEditorControlButtons}
          onDragStart={this.onDragStart}
          onDragEnd={this.onDragEnd}
          onDragEndOnTarget={this.onDragEndOnTarget}
          onDragOver={this.onDragOver}
          onClickFormulaEditorAction={this.onClickFormulaEditorAction}
          onChangeText={this.onChangeFormulaText}
          onClickEntity={this.onClickFormulaEntity}
          formulaEditorEditingEntityId={this.state.formulaEditorEditingEntityId}
          onEditEntityEditor={this.onEditEntityEditor}
          handleChangeCollapseEntity={this.handleChangeCollapseFormulaEntity}
          handleChangeCollapseAllEntity={this.handleChangeCollapseAllFormulaEntity}
          handleDeleteEntity={this.handleDeleteFormulaEntity}
          onCloseEntityEditor={this.onCloseEntityEditor}
          polynomialsList={this.props.polynomialsList.data}
          metricsList={metricsList}
          dimensionsList={this.props.dimensionsList.data}
          functionsList={this.props.functionsList}   
          calendarsList={this.props.calendarsList.data}
          dimensionInstancesOptions={this.props.dimensionInstancesSelectList.status == 200 ? this.props.dimensionInstancesSelectList.data : null}
          dimensionInstancesFetch={this.handleDimensionInstancesSelectControl}
          dimensionInstancesLoading={this.props.dimensionInstancesSelectList.loading}
          handleImportFormulaGrammarPopup={this.handleImportFormulaGrammarPopup}
          escBehaviourHandler={this.setEscBehaviour}
          formulaEditorHideDraggables={this.state.formulaEditorHideDraggables}
          handleHideEditorDraggables={this.handleHideEditorDraggables}
          popupState={popupState}
        />
        <ImportFormulaGrammarPopup
          handleShowPopup={this.handleImportFormulaGrammarPopup}
          handleButton={this.handleImportFormulaFromGrammar}
          loadingButton={this.props.formulaGrammarValidation.loading}
          fullLoading={this.props.formulaGrammarValidation.loading}
          statusButton={this.props.formulaGrammarValidation.status}
          formContent={this.state.formulaImportText}
          popupState={this.state[popupIds.importFormulaGrammarPopup]}
          handleOnChangeFormData={this.handleOnChangeImportFormulaFromGrammarForm}
          errors={this.props.formulaGrammarValidation.errors}
        />        
        <GlassConfirmPopup
          confirmTitle={(<FormattedMessage id={"polynomialAdmin.formulaEditor.closePopupTitle"}/>)}
          confirmText={(<FormattedMessage id={"polynomialAdmin.formulaEditor.closePopupDetail"}/>)}
          handleConfirm={this.handleCloseFormula}
          handleCancel={InterfaceTooling.handleCloseFormulaConfirmPopup.bind(null, this)}
          popupState={InterfaceTooling.getCloseFormulaConfirmPopupState(this)}
          loading={false}
        />
        </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  dimensionsList: state.reducer.formulaEditor.dimensionsList,
  metricsList: state.reducer.formulaEditor.metricsList,
  polynomialsList: state.reducer.formulaEditor.polynomialsList,
  functionsList: state.reducer.formulaEditor.functionsList,
  dimensionInstancesSelectList: state.reducer.formulaEditor.dimensionInstancesSelectList,
  calendarsList: state.reducer.calendarAdmin.calendarList,
  formulaToEditObject: state.reducer.formulaEditor.formulaToEditObject,
  formulaValidation: state.reducer.formulaEditor.formulaValidation,
  formulaGrammarValidation: state.reducer.formulaEditor.formulaGrammarValidation,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(formulaEditorActions, dispatch)
});

FormulaEditor.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FormulaEditor);



// WEBPACK FOOTER //
// ./source/client/containers/formulaEditor/index.jsx